import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";
import svg62 from "../../../assets/svg/svg62.svg";
import { Text } from "recharts";
import { useSelector } from "react-redux";

function ProjectCount() {
  // const data = [
  //   { name: "Planned", value: 60, remaining: 180 },
  //   { name: "Ongoing", value: 80, remaining: 160 },
  //   { name: "Complete", value: 40, remaining: 200 },
  //   { name: "Stalled", value: 20, remaining: 220 },
  //   { name: "Issues", value: 20, remaining: 220 },
  // ];
  const url = "api/v2/dashboard/getProjectDashboardData";
  const { loading, count, data } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));

  const CustomTick = ({ x, y, payload }) => {
    const label =
      payload.value.length > 7
        ? `${payload.value.slice(0, 6)}…`
        : payload.value;
    return (
      <Text
        x={x}
        y={y + 25}
        textAnchor="middle"
        verticalAnchor="start"
        angle={-45}
        className="font-interSans"
        style={{ fontSize: ".79rem", fontWeight: "400", fill: "#1A1A1A" }}
      >
        {label}
      </Text>
    );
  };
  const total = data?.projectData?.reduce((sum, item) => sum + item?.value, 0);

  return (
    <div className="p-[1.25rem] rounded-[.75rem] bg-white   w-full h-full">
      <div className="flex items-center justify-between text-[#424242] font-interSans text-[.75rem] font-[500] mb-[1.18rem]">
        <div className="flex items-center gap-x-[.65rem]">
          <span className="">Projects Count</span>
          <img src={svg62} alt="svg62" />
        </div>

        <div className="bg-[#D6E1F5] rounded-[.5rem] py-[.125rem] px-[.25rem] max-w-[6.875rem] flex items-center justify-center">
          {total}
        </div>
      </div>

      <ResponsiveContainer width="100%" height={300}>
        <BarChart
          data={data?.projectData}
          margin={{ left: -10, bottom: 33 }}
          barCategoryGap={10}
          barGap={0}
        >
          <XAxis
            dataKey="name"
            tick={<CustomTick />}
            // tick={{ angle: -45, dy: 30 }}
            axisLine={true}
            tickLine={true}
          />
          <YAxis
            // domain={[0, 240]}
            // tick={{ dx: 20 }}
            axisLine={true}
            tickLine={true}
          />
          <Tooltip cursor={{ fill: "transparent" }} />

          <Bar dataKey="value" stackId="a" fill="#3B82F6" barSize={30}>
            {data?.projectData?.map((entry, index) => {
              const colorMap = {
                Completed: "#22C55E",
                Ongoing: "#0092CC",
                Planned: "#F59E0B",
                Stalled: "#EF4444",
              };
              return (
                <Cell
                  key={`cell-${index}`}
                  fill={colorMap[entry.name] || "#4F81BD"}
                />
              );
            })}
          </Bar>
          <Bar dataKey="remaining" stackId="a" fill="#E5E7EB" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default ProjectCount;
